'use strict';

import Slider from "../slider/slider";

export default class ParagraphTypeTimeline {
  constructor() {
    const self = this;
    this.slider = new Slider();

    $(".paragraph--type--timeline").each(function (k, v) {
      self.initTimeline($(v).find(">.field--name-field-items"), {});
    });
  }

  initTimeline(el, options) {
    let timelineControl = el.next('.timeline-control');
    
    el.children().map(function(k,v) {
      
      let date = $(v).find('.field--name-field-date .field__item').text();

      const parts = date.split(" ");
      const year = parts[parts.length - 1];
      
      timelineControl.append(`<button class='dot ${k == 0 ? 'active' : ''}' data-index='${k}'>${year}</button>`);
    })


    timelineControl.on('click', '.dot', function() {
      let index = $(this).data('index');
      timelineControl.find('.dot').removeClass('active');
      $(this).addClass('active');
      $(el).find(">.field__item").hide();
      $($(el).children()[index]).fadeIn("slow");
    });
  }
}
